<template>
  <div class="index_index">
    <div class="index_top">
      <el-input
        class="keyword"
        placeholder="请输入船名/MMSI/IMO/CN"
        v-model="keyword"
        @focus="focusSearching"
        @blur="blurSearching"
        @input="searchShips">
      </el-input>
      <div class="ship_search_box">
        <div class="ship_search_history" v-if="searching && !keyword && !shipsVisible">
          <div class="search_history_head">
            <div class="search_history_title">近期搜索船舶：</div> <div class="search_history_clear" @click="clearHistory">清空记录</div>
          </div>
          <div class="search_history_one" v-if="!shipHistory || shipHistory.length<=0">
            暂无搜索记录
          </div>
          <div class="search_history_one" v-for="(item,index) in shipHistory" :key="index">
            <el-tag size="small" @click="directShip(item)">{{item.nameCn || item.name || item.mmsi}}</el-tag>
          </div>
        </div>
        <div class="ship_search_history" v-if="keyword">
          <div class="ship_search_wait" v-if="searching && keyword && !shipsVisible">
            查询中<el-icon class="el-icon-loading"/>
          </div>
          <div class="ship_search_wait" v-if="shipsVisible && (ships==null || ships.length<=0)">
            查无数据
          </div>
          <div class="ships_one" v-for="(item,index) in ships" :key="index" @click="directShip(item)">
            <el-row>
              <el-col :span="24">
                船名: <span :style="(item.nameCn && item.nameCn.indexOf(keyword)>=0) || (item.name && item.name.indexOf(keyword)>=0) ? 'color:rgb(0, 145, 255);' : ''">{{item.nameCn || item.name}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                MMSI: <span :style="item.mmsi.indexOf(keyword)>=0 ? 'color:rgb(0, 145, 255);' : ''">{{item.mmsi}}</span>
              </el-col>
              <el-col :span="12">
                IMO: <span :style="item.imo && item.imo.indexOf(keyword)>=0 ? 'color:rgb(0, 145, 255);' : ''">{{item.imo==null || item.imo===0 || item.imo==='' ? '未知' : item.imo}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                国籍: {{item.flag_name_cn || item.flag_name_en || '未知'}}
              </el-col>
              <el-col :span="12">
                船龄: {{item.date_keel_laid==null || item.date_keel_laid===0 ? '未知' : Math.round((parseInt(new Date().valueOf()/1000) - item.date_keel_laid)/86400/365)}}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                更新时间: {{new Date(item.lasttime*1000).toLocaleString()}} <el-tag style="float:right;" effect="dark" size="mini" v-if="item.lasttime < (new Date().valueOf()/1000)-86400*3">{{expDays(item.lasttime)}}</el-tag>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="index_typhoon" v-if="!shipVisible">
      <el-row v-for="(item,index) in typhoons" :key="index">
        <el-col :span="24">
          <el-button size="small" :type="index%3===0?'danger':(index%3===1?'primary':'success')" @click="toTyphoon(index)">{{item.cname || item.ename}}</el-button>
        </el-col>
      </el-row>
      <el-row v-if="!typhoons || typhoons.length===0">
        <el-col :span="24">
          <el-button size="mini" type="info">暂无台风</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="map">
      <div class="map-container" id="maps"></div>
    </div>
    <div class="typhoon_dialog" v-if="typhoonDialogVisible">
      <el-tag type="primary">{{typhoon.presents[0].present_strong}} [{{typhoon.cname || typhoon.ename}}] {{new Date(typhoon.presents[0].present_time * 1000).toLocaleString()}}</el-tag>
      <el-tag type="warning">风力：{{typhoon.presents[0].present_power}} 级</el-tag>
      <el-tag type="success">风速：{{typhoon.presents[0].present_max_wind_speed}} 米/秒</el-tag>
      <el-tag type="info">经纬度：Lat:{{Math.abs(typhoon.presents[0].present_lat)}}{{typhoon.presents[0].present_lat < 0 ? 'S' : 'N'}}, Lon:{{Math.abs(typhoon.presents[0].present_lon)}}{{typhoon.presents[0].present_lon < 0 ? 'E' : 'W'}}</el-tag>
      <el-tag type="danger">位置： {{typhoonMessage.region_zh}} {{typhoonMessage.distance < 0 ? '沿海' : '内陆'}} {{Math.abs(typhoonMessage.distance)}} 千米</el-tag>
    </div>
    <el-drawer
      :withHeader="false"
      :visible.sync="imgVisible"
      size="50%"
      direction="btt">
    </el-drawer>
    <div class="index_detail" v-if="shipInfoVisible">
      <shipInfo :ship="ship" :credit="credit" @shipInfoClose="closeShipInfo" />
    </div>
    <div class="index_risk" v-if="shipRiskVisible">
      <shipRisk :ship="ship" @shipRiskClose="closeShipRisk" />
    </div>
    <div class="index_vio" v-if="shipVioVisible">
      <shipVio :ship="ship" :credit="credit" @shipVioClose="closeShipVio" />
    </div>
    <div class="index_ship" v-if="shipVisible">
      <el-row style="border-bottom:1px solid #ccc;">
        <el-col :span="20">
          <div class="ship_head">
            <div class="ship_img">
              <img :src="`/static/flags/`+getTwoCode(ship.nationality || ship.flag_name_en)+`.png`" style="height:2rem;" />
            </div>
            <div class="ship_name">
              {{ship.name_cn ? ship.name_cn + ' - ' : ''}}{{ ship.name_en ? ship.name_en : '' }}
            </div>
          </div>
        </el-col>
        <el-col :span="2">
          <div class="ship_head">

          </div>
        </el-col>
        <el-col :span="2">
          <div class="ship_head">
            <div class="index_ship_close" @click="closeShip">✖</div>
          </div>
        </el-col>
      </el-row>
      <el-row class="ship_btn_box">
        <el-col :span="12" class="ship_btn">
          <span @click="showBase">基本信息</span>
        </el-col>
        <el-col :span="12" class="ship_btn">
          <span @click="beginVessel">历史轨迹</span>
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          MMSI:
        </el-col>
        <el-col :span="9">
          {{ship.mmsi}}
        </el-col>
        <el-col :span="4" class="ship_title">
          船舶图片:
        </el-col>
        <el-col :span="8">
          <div class="ship_img_btn" v-if="shipimgs">
            <el-image
              style="height:.8rem;width:1rem;"
              src="/static/imgs/picture.png"
              :preview-src-list="shipimgs">
            </el-image>
          </div>
          <div class="ship_grey" v-if="!shipimgs">无数据</div>
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          IMO:
        </el-col>
        <el-col :span="9" :class="ship.imo && ship.imo !== '' && ship.imo !== 0 ? 'ship_black' : 'ship_grey'">
          {{ship.imo && ship.imo !== '' && ship.imo !== 0 ? ship.imo : "无数据"}}
        </el-col>
        <el-col :span="4" class="ship_title">
          呼号:
        </el-col>
        <el-col :span="8" :class="ship.callsign && ship.callsign !== '' ? 'ship_black' : 'ship_grey'">
          {{ship.callsign && ship.callsign !== '' ? ship.callsign : "无数据"}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          类型:
        </el-col>
        <el-col :span="9" :class="ship.ship_type_others ? 'ship_black' : 'ship_grey'">
          {{ship.ship_type_others || '无数据'}}
        </el-col>
        <el-col :span="4" class="ship_title">
          注册号:
        </el-col>
        <el-col :span="8" :class="ship.regist_number ? 'ship_black' : 'ship_grey'">
          {{ship.regist_number || '无数据'}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          宽度:
        </el-col>
        <el-col :span="9" :class="ship.width && ship.width !== 0 ? 'ship_black' : 'ship_grey'">
          {{ship.width && ship.width !== 0 ? ship.width/10+'米' : "无数据"}}
        </el-col>
        <el-col :span="4" class="ship_title">
          长度:
        </el-col>
        <el-col :span="8" :class="ship.length && ship.length !== 0 ? 'ship_black' : 'ship_grey'">
          {{ship.length && ship.length !== 0 ? ship.length/10+'米' : "无数据"}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          总吨:
        </el-col>
        <el-col :span="9" :class="ship.gt_final && ship.gt_final > 0 ? 'ship_black' : 'ship_grey'">
          {{ship.gt_final && ship.gt_final > 0 ? ship.gt_final : "无数据"}}
        </el-col>
        <el-col :span="4" class="ship_title">
          吃水:
        </el-col>
        <el-col :span="8" :class="ship.draught && ship.draught !== 0 ? 'ship_black' : 'ship_grey'">
          {{ship.draught && ship.draught !== 0 ? ship.draught/10+'米' : "无数据"}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          船籍港:
        </el-col>
        <el-col :span="9" :class="ship.home_port && ship.home_port !== '' ? 'ship_black' : 'ship_grey'">
          {{ship.home_port && ship.home_port !== '' ? ship.home_port : "无数据"}}
        </el-col>
        <el-col :span="4" class="ship_title">
          建造日期:
        </el-col>
        <el-col :span="8" :class="(ship.date_build && ship.date_build) || (ship.date_keel_laid && ship.date_keel_laid !== 0) !== 0 ? 'ship_black' : 'ship_grey'">
          {{ship.date_build && ship.date_build !== 0 ? new Date(ship.date_build*1000).toLocaleDateString() : (ship.date_keel_laid && ship.date_keel_laid !== 0 ? new Date(ship.date_keel_laid*1000).toLocaleDateString() : "无数据")}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          经度:
        </el-col>
        <el-col :span="9">
          {{decimalToSexagesimal(ship.lon/600000) + (ship.lon >= 0 ? 'E' : 'W')}}
        </el-col>
        <el-col :span="4" class="ship_title">
          纬度:
        </el-col>
        <el-col :span="8">
          {{decimalToSexagesimal(ship.lat/600000) + (ship.lat >= 0 ? 'N' : 'S')}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          船首向:
        </el-col>
        <el-col :span="9" :class="ship.hdg ? 'ship_black' : 'ship_grey'">
          {{ship.hdg ? (ship.hdg%360)+'°' : '无数据'}}
        </el-col>
        <el-col :span="4" class="ship_title">
          船迹向:
        </el-col>
        <el-col :span="8" :class="ship.cog ? 'ship_black' : 'ship_grey'">
          {{ship.cog ? (ship.cog%360)+'°' : '无数据'}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          状态:
        </el-col>
        <el-col :span="9" :class="ship.navistat && ship.navistat <= 9 ? 'ship_black' : 'ship_grey'">
          {{ship.navistat!=null ? navistats[ship.navistat] : '未知'}}
        </el-col>
        <el-col :span="4" class="ship_title">
          上报时间:
        </el-col>
        <el-col :span="8">
          {{new Date(ship.lasttime*1000).toLocaleString()}}
        </el-col>
      </el-row>
      <el-row class="ship_row">
        <el-col :span="3" class="ship_title">
          航速:
        </el-col>
        <el-col :span="9" :class="ship.sog && ship.sog >=0 ? 'ship_black' : 'ship_grey'">
          {{ship.sog!=null ? ship.sog/10+'节' : '未知'}}
        </el-col>
      </el-row>
    </div>
    <div class="index_vessel" :style="`display:`+(vesselVisible?'block;':'none;')">
      <el-row style="border-bottom:1px solid #ccc;">
        <el-col :span="20">
          <div class="vessel_head">
            <div class="vessel_img">
              <img :src="`/static/flags/`+getTwoCode(ship.nationality || ship.flag_name_en)+`.png`" style="height:2rem;" />
            </div>
            <div class="vessel_name">
              {{ship.name_cn ? ship.name_cn + ' - ' : ''}}{{ ship.name_en ? ship.name_en : '' }}
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="index_vessel_close" @click="closeVessel">﹀</div>
        </el-col>
      </el-row>
      <el-row style="height:5vh;line-height:5vh;border-bottom:1px solid #ccc;text-align:center;">
        <el-col :span="2">
          <el-color-picker v-model="color" @change="colorChange" :show-alpha="true" size="medium" />
        </el-col>
        <el-col :span="4">
          {{vdays[0]===0 ? '今天' : vdays[0]+'天前'}}
        </el-col>
        <el-col :span="14">
          <el-slider v-model="vdays" range input-size="mini" :min="0" :max="90" :show-tooltip="false" @change="vdaysChange" />
        </el-col>
        <el-col :span="4">
          {{vdays[1]===0 ? '今天' : vdays[1]+'天前'}}
        </el-col>
      </el-row>
      <el-row class="vessel_row">
        <el-col :span="24">
          <el-tag type="primary">AIS信号: {{ais ? ais+'%' : '未知'}}</el-tag>
          <el-tag type="success">设计航速: {{vesselData.in_set_speed ? vesselData.in_set_speed : '无数据'}}</el-tag>
          <el-tag type="danger">超高航速: {{vesselData.over_high_speed_ratio ? (vesselData.over_high_speed_ratio * 100).toFixed(2)+'%' : '无数据'}}</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div id="vcharts" ref="vcharts" style="width:100%;height:12vh;"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { getTyphoonActive,searchShips,getShipBase,getShipImgs,
    getVesselSum,getCreditFinalV3,checkValidUrl,getShipScore } from '../../api/api'
  import { wechatPayAccessGoods } from '../../util/pay'
  import 'leaflet/dist/leaflet.css'
  import L from 'leaflet'
  import 'leaflet-semicircle'
  import 'leaflet-rotatedmarker'
  import { expDays,parseVesselDataForECharts,parseVesselEchartsOptions } from '../../util/common'
  import { getNearestCountry,getCountryCodeTwoByThree,decimalToSexagesimal } from '../../util/geoutil'
  import { getJsonStorage,setJsonStorage,getShipSearchStorage,updateShipSearchStorage,clearShipSearchStorage } from "../../util/storage";
  import shipInfo from '../ship/info'
  import shipRisk from '../ship/risk'
  import shipVio from '../ship/vio'
  export default {
    name: 'IndexShip',
    components:{
      shipInfo,
      shipRisk,
      shipVio
    },
    data () {
      return {
        mmsi:this.$route.query.mmsi,
        map: null,
        layers: null,
        keyword:"",
        ua:"",
        typhoons:[],
        typhoonMakers: [],
        typhoonPaths: [],
        typhoonRadius: [],
        typhoonPoints: [],
        typhoonIcon:null,
        pointIcon:[],
        typhoonMessage: null,
        typhoonDialogVisible:false,
        typhoonMarkersGroup: null,
        typhoonRadiusGroup: null,
        typhoonPathsGroup: null,
        typhoonPointsGroup: null,
        inputSwitch: null,
        ships:[],
        shipsVisible:false,
        ship:{},
        credit:{},
        shipScore:{},
        shipVisible:false,
        vesselPoints:[],
        vesselPaths:[],
        vesselPointsGroup: null,
        vesselPathsGroup: null,
        vesselVisible:false,
        vesselData: {},
        vesselSwitch: null,
        shipInfoVisible: false,
        shipRiskVisible: false,
        shipVioVisible: false,
        maxSpeed: 0,
        shipHistory:getShipSearchStorage(),
        ais: null,
        shipMarker:null,
        shipimgs:null,
        imgVisible:false,
        vdays: [0,30],
        color:'rgba(64,157,255,0.7)',
        navistats:['发动机使用中','锚泊','未操纵','有限适航性','受船舶吃水限制','系泊','搁浅','从事捕捞','航行中','未定义','未定义','未定义','未定义','未定义','未定义','未定义'],
        echart:null,
        searching: false,
        chartData: {
          grid: {
            top: 20,
            left: 30,
            right:20,
            bottom: 35
          },
          xAxis: {
            type: 'time',
            boundaryGap: false
          },
          yAxis: [
            {
              type: 'value'
            },
            {
              type: 'value'
            },
            {
              type: 'value'
            },
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'line',
              data: [],
              large: true,
              color: 'lightblue'
            },
            {
              type: 'bar',
              stack: 'Ad',
              data: [],
              large: true,
              color: 'green'
            },
            {
              type: 'bar',
              stack: 'Ad',
              data: [],
              large: true,
              color: 'yellow'
            },
            {
              type: 'bar',
              stack: 'Ad',
              data: [],
              large: true,
              color: 'red'
            }
          ]
        }
      }
    },
    mounted(){
      this.typhoonIcon = L.icon({
        iconUrl: require('../../../static/imgs/typhoon.gif'),
        iconSize: [32,32]
      });
      this.pointIcon.push(L.icon({
        iconUrl: require('../../../static/imgs/point.png'),
        iconSize: [8,8]
      }));
      this.pointIcon.push(L.icon({
        iconUrl: require('../../../static/imgs/pointB.png'),
        iconSize: [8,8]
      }));
      this.pointIcon.push(L.icon({
        iconUrl: require('../../../static/imgs/pointY.png'),
        iconSize: [8,8]
      }));
      this.pointIcon.push(L.icon({
        iconUrl: require('../../../static/imgs/pointO.png'),
        iconSize: [8,8]
      }));
      this.pointIcon.push(L.icon({
        iconUrl: require('../../../static/imgs/pointR.png'),
        iconSize: [8,8]
      }));
      this.getMap();
      this.getTyphoon();
      if(this.mmsi){
        this.getShip({mmsi:this.mmsi});
      }else{
        setTimeout(()=>{
          if(this.typhoons.length > 0){
            this.toTyphoon(0);
          }
        },2000);
      }
    },
    methods: {
      getMap() {
        const maxBounds = new L.LatLngBounds(new L.LatLng(-80, -360), new L.LatLng(80, 360));
        this.map = L.map('maps', {
          minZoom: 2,
          maxZoom: 11,
          center: [29.6, 106.9],
          zoom: 3,
          maxBounds: maxBounds,
          maxNativeZoom: 8,
          noWarp: true,
          zoomControl: false,
          attributionControl: false,
          latLngsToCoords: true,
          crs: L.CRS.EPSG3857
        }).fitWorld().setView([29.6, 106.9], 3);
        this.layers = L.tileLayer("https://cdn.anlantech.cn/v1/tile/marine/{z}/{y}/{x}.png", {
          minZoom: 2,
          maxZoom: 11,
          maxNativeZoom: 8,
          zoom: 3
        }).addTo(this.map);
        L.tileLayer("http://green.anlantech.cn/{z}/{y}/{x}.png", {
          minZoom: 2,
          maxZoom: 11,
          minNativeZoom: 3,
          maxNativeZoom: 9,
          zoom: 3,
        }).addTo(this.map);
      },
      getTyphoon(){
        getTyphoonActive().then(res => {
          if(res.data && res.data!=null && res.data.length > 0){
            this.typhoons = [];
            this.typhoonMakers = [];
            this.typhoonRadius = [];
            this.typhoonPoints = [];
            for(let d in res.data){
              this.makerTyphoon(res.data[d],d);
              this.radiusTyphoon(res.data[d]);
              this.pathTyphoon(res.data[d].presents[0].forecasts);
              this.pointTyphoon(res.data[d]);
            }
            this.typhoonMarkersGroup = L.layerGroup(this.typhoonMakers);
            this.typhoonRadiusGroup = L.layerGroup(this.typhoonRadius);
            this.typhoonPathsGroup = L.layerGroup(this.typhoonPaths);
            this.typhoonPointsGroup = L.layerGroup(this.typhoonPoints);
            this.typhoonMarkersGroup.addTo(this.map);
            this.typhoonRadiusGroup.addTo(this.map);
            this.typhoonPathsGroup.addTo(this.map);
            this.typhoonPointsGroup.addTo(this.map);
          }
        })
      },
      makerTyphoon(data,index){
        this.typhoons.push(data);
        let maker = L.marker({lat:data.presents[0].present_lat,lon:data.presents[0].present_lon},{
          icon:this.typhoonIcon,
        }).on('click',(e)=>{
          this.toTyphoon(index);
        });
        this.typhoonMakers.push(maker);
      },
      radiusTyphoon(data){
        if(data.presents[0].present_seven_radius_values.nwq > 0){
          this.semiCircle(data.presents[0].present_lat,data.presents[0].present_lon,data.presents[0].present_seven_radius_values,0.2);
        }
        if(data.presents[0].present_ten_radius_values.nwq > 0){
          this.semiCircle(data.presents[0].present_lat,data.presents[0].present_lon,data.presents[0].present_ten_radius_values,0.3);
        }
        if(data.presents[0].present_twelve_radius_values.nwq > 0){
          this.semiCircle(data.presents[0].present_lat,data.presents[0].present_lon,data.presents[0].present_twelve_radius_values,0.4);
        }
      },
      toTyphoon(index){
        this.typhoon = this.typhoons[index];
        this.map.setView({lat:this.typhoons[index].presents[0].present_lat-2,lng:this.typhoons[index].presents[0].present_lon},5);
        this.typhoonMessage = getNearestCountry({latitude:this.typhoons[index].presents[0].present_lat,longitude:this.typhoons[index].presents[0].present_lon});
        this.typhoonDialogVisible = true;
      },
      pathTyphoon(forecasts){
        let latlngs = [];
        let reve = forecasts[0].forecast_lon > 0;
        for(let f in forecasts){
          latlngs.push([forecasts[f].forecast_lat,forecasts[f].forecast_lon<=0 && reve ? forecasts[f].forecast_lon+360 : forecasts[f].forecast_lon]);
        }
        let lines = L.polyline(latlngs, {color:'rgba(58,167,194,0.7)',dashArray: [2,4]});
        this.typhoonPaths.push(lines);
      },
      pointTyphoon(data){
        let forecasts = data.presents[0].forecasts;
        let reve = forecasts[0].forecast_lon > 0;
        for(let f in forecasts){
          let point = L.marker({lat:forecasts[f].forecast_lat,lng:forecasts[f].forecast_lon<=0 && reve ? forecasts[f].forecast_lon+360 : forecasts[f].forecast_lon},{
            title: forecasts[f].forecast_strong + '\r\n' + new Date(forecasts[f].forecast_time * 1000).toLocaleString()+'\r\n风力:'+forecasts[f].forecast_power + '级, 风速:'+forecasts[f].forecast_max_wind_speed+'m/s',
            icon:forecasts[f].forecast_power > 14 ? this.pointIcon[4] : (forecasts[f].forecast_power > 11 ? this.pointIcon[3] : (forecasts[f].forecast_power > 9 ? this.pointIcon[2] : this.pointIcon[1]))
          });
          this.typhoonPoints.push(point);
        }
      },
      semiCircle(lat,lon,nwse,opacity){
        let ne = L.semiCircle({lat:lat,lng:lon},{
          radius:nwse.neq * 1000,
          startAngle:0,
          stopAngle:90,
          fill:true,
          fillColor:'#fa3',
          fillOpacity:opacity,
          opacity:0
        });
        this.typhoonRadius.push(ne);
        let se = L.semiCircle({lat:lat,lng:lon},{
          radius:nwse.seq * 1000,
          startAngle:90,
          stopAngle:180,
          fill:true,
          fillColor:'#fa3',
          fillOpacity:opacity,
          opacity:0
        });
        this.typhoonRadius.push(se);
        let sw = L.semiCircle({lat:lat,lng:lon},{
          radius:nwse.swq * 1000,
          startAngle:180,
          stopAngle:270,
          fill:true,
          fillColor:'#fa3',
          fillOpacity:opacity,
          opacity:0
        });
        this.typhoonRadius.push(sw);
        let nw = L.semiCircle({lat:lat,lng:lon},{
          radius:nwse.nwq * 1000,
          startAngle:270,
          stopAngle:360,
          fill:true,
          fillColor:'#fa3',
          fillOpacity:opacity,
          opacity:0
        });
        this.typhoonRadius.push(nw);
      },
      searchShips(){
        this.typhoonDialogVisible = false;
        if(this.inputSwitch!=null){
          clearTimeout(this.inputSwitch);
          this.ships = [];
          this.searching = true;
          this.shipsVisible = false;
        }
        if(this.keyword != null && this.keyword !== ''){
          this.inputSwitch = setTimeout(()=>{
            if(this.keyword.length<3){
              this.$message.error({showClose:true,duration:3000,message:'请输入至少3个字符'});
              return;
            }
            this.keyword = this.keyword.toUpperCase();
            searchShips(this.keyword).then(res => {
              this.shipsVisible = true;
              if(res && res.status === 0){
                this.ships = res.data;
              }
            });
          },800);
        }else{
          this.shipsVisible = false;
          this.searching = true;
        }
      },
      directShip(item){
        this.$router.push('/index/ship?mmsi='+item.mmsi);
        this.getShip(item);
      },
      getShip(item){
        this.shipVisible = false;
        this.vesselVisible = false;
        let mmsi = item.mmsi;
        getShipBase(mmsi).then(res => {
          if(res && res.status === 0 && res.data){
            if(item.lasttime) this.shipHistory = updateShipSearchStorage(item);
            this.ship = res.data;
            this.shipsVisible = false;
            this.ships = [];
            this.keyword = '';
            this.shipVisible = true;
            this.shipMarker = L.marker({lat:this.ship.lat/600000,lng:this.ship.lon/600000},{
              icon:L.icon({
                iconUrl: require('../../../static/imgs/posTap.png'),
                iconSize: [12,24]
              }),
              rotationAngle: this.ship.hdg ? this.ship.hdg/10 : (this.ship.cog ? this.ship.cog/10 : 0)
            });
            this.shipMarker.addTo(this.map);
            this.viewShip();
            this.shipimgs = null;
            checkValidUrl('/datacenter/standard/riskv4/ship/score',{mmsi:this.ship.mmsi.toString()}).then(res => {
              if(res && res.status === 0){
                this.userValid = res.data;
              }
            });
            getShipImgs({mmsi:this.ship.mmsi,imo:this.ship.imo && this.ship.imo !== '' ? this.ship.imo : 0}).then(res => {
              if(res && res.status === 0 && res.data){
                this.shipimgs = res.data;
              }
            });
            getCreditFinalV3({
              mmsi:this.ship.mmsi,imo:this.ship.imo,
              shipname_en:this.ship.name_en,
              shipname_cn:this.ship.name_cn,
              name_clean_id:this.ship.name_clean_id,
              shipowner:this.ship.shipowner_ch
            }).then(res => {
              if(res && res.status === 0 && res.data){
                this.credit = res.data;
              }
            });
          }
        });
      },
      viewShip(){
        this.map.setView({lat:this.ship.lat/600000-3,lng:this.ship.lon/600000},5);
      },
      beginVessel(){
        let now = parseInt(new Date().valueOf()/1000);
        let loading = this.$loading({text:'加载中...',spinner:'el-icon-loading'});
        getVesselSum(this.ship.mmsi,now-(this.vdays[1]*86400),now-(this.vdays[0]*86400)).then(res => {
          if(res && res.status === 0 && res.data){
            this.vesselData = res.data;
            this.drawVessel();
          }else{
            if(this.echart != null) this.echart.clear();
            this.vesselData = {};
            this.maxSpeed = null;
            this.ais = null;
            this.shipVisible = false;
            this.vesselVisible = true;
            if(this.vesselPointsGroup != null){
              this.map.removeLayer(this.vesselPointsGroup);
              this.vesselPointsGroup = null;
              this.vesselPoints = [];
            }
            if(this.vesselPathsGroup != null){
              this.map.removeLayer(this.vesselPathsGroup);
              this.vesselPathsGroup = null;
              this.vesselPaths = [];
            }
            this.$message.warning(this.vdays[0]+'到'+this.vdays[1]+'天前,无轨迹数据');
          }
        }).finally(res => {
          if(loading!=null) loading.close();
        });
      },
      drawVessel(){
        if(this.vesselPointsGroup != null){
          this.map.removeLayer(this.vesselPointsGroup);
          this.vesselPointsGroup = null;
          this.vesselPoints = [];
        }
        if(this.vesselPathsGroup != null){
          this.map.removeLayer(this.vesselPathsGroup);
          this.vesselPathsGroup = null;
          this.vesselPaths = [];
        }
        let latlngs = [];
        if(this.vesselData.ol && this.vesselData.ol.length>0){
          for(let o in this.vesselData.ol){
            this.vesselPoints.push(L.marker({lat:(this.vesselData.ol[o].lat/1000000).toFixed(6),lng:(this.vesselData.ol[o].lon/1000000).toFixed(6)},{
              title: new Date(this.vesselData.ol[o].utc * 1000).toLocaleString() + '\r\n航速:' + (this.vesselData.ol[o].sog/514.444).toFixed(1) + '节\r\n经纬度:'+Math.abs(this.vesselData.ol[o].lon/1000000).toFixed(6)+(this.vesselData.ol[o].lon>=0?'E':'W')+','+Math.abs(this.vesselData.ol[o].lat/1000000).toFixed(6)+(this.vesselData.ol[o].lat>=0?'N':'S'),
              icon:L.icon({
                iconUrl: require('../../../static/imgs/pointB.png'),
                iconSize: [6,6]
              })
            }));
            latlngs.push([(this.vesselData.ol[o].lat/1000000).toFixed(6),(this.vesselData.ol[o].lon/1000000).toFixed(6)]);
            if((this.vesselData.ol[o].sog/514.444).toFixed(1) > this.maxSpeed){
              this.maxSpeed = (this.vesselData.ol[o].sog/514.444).toFixed(1);
            }
          }
          this.ais = (latlngs.length / ((this.vdays[1]-this.vdays[0])*86400000) * 360000000).toFixed(0);
          this.vesselPaths.push(L.polyline(latlngs, {color:this.color,dashArray: [3,6]}));
          this.vesselPointsGroup = L.layerGroup(this.vesselPoints);
          this.vesselPathsGroup = L.layerGroup(this.vesselPaths);
          this.vesselPointsGroup.addTo(this.map);
          this.vesselPathsGroup.addTo(this.map);
          this.map.setView([this.ship.lat/600000-2,this.ship.lon/600000],6);
          this.shipVisible = false;
          this.vesselVisible = true;
        }
        let opData = parseVesselDataForECharts(this.vesselData.ol);
        let option = parseVesselEchartsOptions(this.chartData,opData,this.vdays[1]-this.vdays[0]);
        this.echart = this.$echarts.init(this.$refs.vcharts,null,{width:document.documentElement.clientWidth,height:document.documentElement.clientHeight/5});
        this.echart.setOption(option);
      },
      closeShip(){
        this.map.removeLayer(this.shipMarker);
        this.shipMarker = null;
        this.shipVisible = false;
        this.$router.push('/index/ship');
      },
      closeVessel(){
        if(this.vesselPointsGroup != null){
          this.map.removeLayer(this.vesselPointsGroup);
          this.vesselPointsGroup = null;
        }
        if(this.vesselPathsGroup != null){
          this.map.removeLayer(this.vesselPathsGroup);
          this.vesselPathsGroup = null;
        }
        this.vesselPoints = [];
        this.vesselPaths = [];
        this.shipVisible = true;
        this.vesselVisible = false;
      },
      closeShipInfo(){
        this.shipInfoVisible = false;
      },
      closeShipRisk(){
        this.shipRiskVisible = false;
      },
      closeShipVio(){
        this.shipVioVisible = false;
      },
      showBase(){
        this.shipInfoVisible = true;
      },
      clearHistory(){
        this.shipHistory = clearShipSearchStorage();
      },
      focusSearching(){
        this.searching = true;
        this.shipVisible = false;
      },
      blurSearching(){
        setTimeout(()=>{
          this.searching = false;
        },100)
      },
      expDays(timestamp){
        let days = expDays(timestamp,3);
        if(days > 0) return days+'天前';
        return '3天内';
      },
      getTwoCode(code){
        return getCountryCodeTwoByThree(code);
      },
      decimalToSexagesimal(latlng){
        return decimalToSexagesimal(latlng);
      },
      vdaysChange(val){
        this.vdays = val;
        this.beginVessel();
      },
      colorChange(val){
        this.color = val;
        this.drawVessel();
      }
    }
  }
</script>

<style scoped="scoped">
  .map-container {
    position:absolute;
    top:6vh;
    left:0;
    width: 100%;
    height: 94vh;
  }
  .map {
    position:absolute;
    top:0;
    left:0;
    width: 100%;
    height: 94vh;
    z-index:1;
  }
  #maps {
    z-index:2;
  }
  .index_top {
    position:absolute;
    top:7vh;
    height:6vh;
    width:96%;
    z-index: 99;
  }
  .keyword {
    margin: 0 10% 0 10%;
    padding:0;
    width:80%;
    float:right;
  }
  .index_typhoon {
    z-index: 9;
    position: absolute;
    top:16vh;
    width:20%;
    float:left;
    text-align:left;
  }
  .index_typhoon .el-button {
    float:left;
  }
  .typhoon_dialog {
    position: absolute;
    margin: 0 15%;
    width:60%;
    bottom:6vh;
    height:20vh;
    border-radius:1rem;
    font-size:.8rem;
    z-index: 8;
    text-align:center;
  }
  .typhoon_dialog p {
    height:2vh;
    line-height:2vh;
  }
  .ships_one {
    padding:.5rem .5rem;
    border-top: 1px dashed #ccc;
    height:6rem;
    font-size:.75rem;
  }
  .ships_one .el-row {
    padding: .2rem 0;
    cursor: pointer;
  }
  .index_ship {
    position: absolute;
    bottom:0;
    left:0;
    height:45vh;
    width:100%;
    background-color:#eee;
    z-index:10;
    font-size:.8rem;
    padding-top:1vh;
  }
  .index_ship_close {
    float:right;
    color:#aaa;
    width:2rem;
    height:4vh;
    line-height:4vh;
    font-size:1rem;
    text-align:center;
    cursor:pointer;
  }
  .ship_head {
    height:4vh;
    line-height:4vh;
  }
  .ship_img {
    float:left;
    width:2.5rem;
    height:2rem;
    margin-left:1rem;
  }
  .ship_name {
    height:2rem;
    line-height:2rem;
    font-size:.9rem;
  }
  .ship_row {
    padding: .4rem 0 0 .8rem;
    font-size: .75rem;
  }
  .ship_title {
    color: #666;
    font-size:.7rem;
  }
  .ship_grey {
    color: #666;
  }
  .ship_img_btn {
    color:#409EFF;
    cursor:pointer;
  }
  .ship_btn_box {
    width:100%;
    height:4vh;
    line-height:3vh;
  }
  .ship_btn {
    text-align:center;
    padding:.2rem 0 .5rem 0;
    border-bottom:1px solid #ccc;
    color:#409EFF;
    font-weight:bold;
    height:4vh;
    line-height:3vh;
    cursor:pointer;
  }
  .ship_cancel {
    text-align:center;
    padding:.2rem 0 .5rem 0;
    border-bottom:1px solid #ccc;
    color:#999;
    font-weight:bold;
    height:4vh;
    line-height:3vh;
  }
  .ship_btn span{
    cursor:pointer;
  }
  .ship_cancel span{
    cursor:pointer;
  }
  .index_vessel {
    position: absolute;
    bottom:0;
    left:0;
    height:40vh;
    width:100%;
    background-color:#eee;
    z-index:10;
    font-size:.8rem;
    padding-top:1vh;
  }
  .index_vessel_close {
    float:right;
    color:#aaa;
    width:2rem;
    height:1rem;
    line-height:1.5rem;
    font-size:1rem;
    font-weight:bold;
    text-align:center;
    cursor:pointer;
  }
  .vessel_head {
    padding-left:1rem;
    height:4vh;
  }
  .vessel_img {
    float:left;
    width:2.5rem;
    height:2rem;
  }
  .vessel_name {
    height:2rem;
    line-height:2rem;
    font-size:.9rem;
  }
  .vessel_row{
    padding: .4rem 0 0 .8rem;
    font-size: .75rem;
  }
  .index_detail{
    position:absolute;
    top:0;
    left:0;
    height:100vh;
    width:100%;
    overflow-y:scroll;
    overflow-x:hidden;
    z-index:99;
    background-color:#eee;
  }
  .index_risk{
    position:absolute;
    top:0;
    left:0;
    height:100vh;
    width:100%;
    overflow-y:scroll;
    overflow-x: hidden;
    z-index:99;
    background-color:#eee;
  }
  .index_vio {
    position:absolute;
    top:0;
    left:0;
    height:100vh;
    width:100%;
    overflow-y:scroll;
    z-index:99;
    background-color:#eee;
  }
  .ship_search_box {
    position:absolute;
    top:7vh;
    left:10%;
    width:80%;
    max-height:80vh;
    background-color:white;
    z-index:999;
    border-radius: .3rem;
    overflow-y: scroll;
  }
  .search_history_head {
    border-bottom: 1px solid #ddd;
    font-size:.95rem;
    color:#777;
    height:4vh;
    line-height:4vh;
    text-indent: .8rem;
  }
  .search_history_title {
    width:65%;
    float:left;
  }
  .search_history_clear {
    width:30%;
    float:left;
    font-size:.75rem;
    text-align:right;
    color:#999;
  }
  .search_history_one {
    float:left;
    margin: 1vh 0 1vh .8rem;
    font-size:.8rem;
    color:#999;
  }
  .ship_search_wait {
    font-size:.8rem;
    color:#999;
    text-align:center;
    height:5vh;
    line-height:5vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/ship.vue